<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs3 />
      <v-flex xs6 :class="streamingCardClasses">
        <next-event-card class="streamingInfo" v-if="shouldDisplayNextEventCard" />
        <v-card
          class="streamingInfo"
          v-else-if="$store.getters.getLivechannel.streaming === true && $store.getters.getNextEvent === null">
          <v-card-title primary-title>
            <v-flex xs12>Unscheduled streaming</v-flex>
          </v-card-title>
        </v-card>
        <v-card class="streamingInfo" v-else>
          <v-card-title primary-title>
            <v-flex xs12>No classes scheduled</v-flex>
          </v-card-title>
        </v-card>
        <v-flex xs12>
          <streaming-controls
            :enable-play-button="$store.getters.getStreamingAvailable && !$store.getters.getLivechannel.streaming"
            :enable-stop-button="$store.getters.getLivechannel.streaming"
            @onStart="startStreaming"
            @onStop="stopStreaming" />
        </v-flex>
      </v-flex>
    </v-layout>
    <streaming-dialog
      :show="showDialog"
      :cannot-cancel-anymore="cannotCancelAnymore"
      :dialog-text="dialogText"
      :dialog-timer="dialogTimer"
      @cancel="cancelStreaming" />
  </v-container>
</template>

<script>
import NextEventCard from "./live/NextEventCard";
import StreamingDialog from "./live/StreamingDialog";
import StreamingControls from "./live/StreamingControls";

export default {
  components: {
    NextEventCard,
    StreamingDialog,
    StreamingControls
  },
  data() {
    return {
      showDialog: false,
      dialogText: "",
      dialogTimer: 0,
      cannotCancelAnymore: false,
      interval: null
    };
  },
  methods: {
    showStreamingDialog(text, time, isStarting) {
      if (this.showDialog) {
        return;
      }

      this.dialogText = text;
      this.dialogTimer = time;

      this.interval = setInterval(() => {
        if (this.dialogTimer > 0) {
          this.dialogTimer--;
        } else if (this.dialogTimer <= 0) {
          this.showDialog = false;
          this.cannotCancelAnymore = false;
          clearInterval(this.interval);
        }
        if (isStarting && this.dialogTimer === time / 2) {
          this.cannotCancelAnymore = true;
          this.$store.dispatch("startStreaming");
        }
      }, 1000);

      this.showDialog = true;
    },
    startStreaming() {
      this.showStreamingDialog("Starting to stream in:", 60, true);
    },
    stopStreaming() {
      this.$store.dispatch("stopStreaming");
      this.showStreamingDialog("Stopping streaming", 45, false);
    },
    cancelStreaming() {
      if (this.interval !== null) {
        clearInterval(this.interval);
      }
      this.showDialog = false;
      this.cannotCancelAnymore = false;
    }
  },
  computed: {
    shouldDisplayNextEventCard() {
      if (this.$store.getters.getNextEvent === null) {
        return false;
      }
      if (
        this.$store.getters.getNextEvent &&
        this.$store.getters.getNextEvent.status === "idle" ||
        this.$store.getters.getNextEvent.status === "streaming"
      ) {
        return true;
      }
      
      return false;
      
    },
    streamingCardClasses() {
      return this.$store.getters.getLivechannel.streaming === true
        ? "font-number text-xs-center card-border streaming-active"
        : "font-number text-xs-center card-border weekendBack";
    },
    getStreamingStateText() {
      switch (this.$store.getters.getNextEvent.status) {
        case "idle": return "Waiting";
        case "streaming": return "Waiting";
        case "done": return "Done";
        case "cancelled": return "Cancelled";
        case "missed": return "Missed";
        default: return "";
      }
    }
  }
};
</script>

<style scoped>
.streamingInfo {
  background: none;
  border: none;
}
.weekendBack {
  background: linear-gradient(#303030, #252525 20%, #252525 80%, #303030);
  min-height: 100%;
}
.streaming-active {
  background: linear-gradient(#4b3c3c, #252525 20%, #252525 80%, #4b3c3c);
  min-height: 100%;
}

.card-border {
  border-right: 2px solid;
  border-left: 2px solid;
  border-image: linear-gradient(
    to top,
    #303030,
    #707070 30%,
    #707070 70%,
    #303030
  );
  border-image-slice: 1;
}
.btn--large {
  font-size: 30px !important;
}
</style>




// WEBPACK FOOTER //
// src/components/Live.vue